import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface MobileTableProps {
  data: any[];
  columns: {
    key: string;
    label: string;
    render?: (value: any, item: any) => React.ReactNode;
  }[];
  actions?: (item: any) => React.ReactNode;
  emptyMessage?: string;
}

export const MobileTable = ({ data, columns, actions, emptyMessage = "No data available" }: MobileTableProps) => {
  if (data.length === 0) {
    return (
      <Card className="touch-target">
        <CardContent className="p-6 text-center text-muted-foreground mobile-body">
          {emptyMessage}
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3 scroll-smooth-mobile">
      {data.map((item, index) => (
        <Card key={index} className="overflow-hidden touch-target tap-highlight-none">
          <CardContent className="p-4">
            <div className="space-y-3">
              {columns.map((column) => (
                <div key={column.key} className="flex justify-between items-start gap-2">
                  <span className="text-sm font-medium text-muted-foreground min-w-0 flex-shrink-0">
                    {column.label}:
                  </span>
                  <div className="text-sm text-right min-w-0 flex-1 break-words">
                    {column.render 
                      ? column.render(item[column.key], item)
                      : item[column.key] || '-'
                    }
                  </div>
                </div>
              ))}
              {actions && (
                <div className="pt-3 border-t flex justify-end gap-2">
                  {actions(item)}
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};